export default __webpack_public_path__ + "static/media/1-icon-list-view.71858d3c.svg";